import React from 'react';

export const GetUiId = string => {
  return string.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (/\s+/.test(match)) return "-";
    if (+match === 0) return "";
    return match.toLowerCase();
  });
}
